export default __webpack_public_path__ + "static/media/ios.ddb2f60a.svg";